import { observable, makeObservable } from 'mobx';
import { useStores } from '../useStores';
import withActions from '../withActions';
import actions from './actions';

export default class AnimationsStore {
    version = '2.0';
    observed = {
        progress: false,
    };

    animationIn = () => {};
    animationOut = () => {};

    onComplete = () => {};
    onStart = () => {};

    viewFunc = null;
    duration = 0.200;
    direction = '';
    incomingView = '';
    outgoingView = '';

    currentName = '';
    nextName = '';
    backName = '';

    constructor() {
        makeObservable(this, {
            observed: observable,
        });
        withActions(this, actions);
    }

}

export function useAnimationsStore () {
    const { store } = useStores();
    return store.animationsStore;
}
